namespace Matrix.Data {
    export class DateColumns {
        static columnsKey = 'Data.Date';
    }
}
